import colors from 'vuetify/es5/util/colors'

export const ASS_OPEN_FOR_AGE_RANGE = {
  12: {min: 11, max: 15},
  18: {min: 16, max: 21},
  24: {min: 22, max: 30}
}

const langThemeDefault = {
  primary: colors.amber.darken4,
  secondary: colors.deepOrange.base,
  accent: colors.blue.accent1,
  error: colors.red.accent2,
  info: colors.blue.base,
  success: colors.green.base,
  warning: colors.amber.base
}

const langThemeZh = {
  primary: colors.blue.darken2,
  secondary: colors.indigo.darken1
}

export const LANG_THEMES = {
  en: langThemeDefault,
  es: langThemeDefault,
  'zh-tw': langThemeZh,
  'zh-cn': langThemeZh
}



// WEBPACK FOOTER //
// ./src/constants/index.js